import Vue from 'vue'
import modalEnergyPrice from '../../components/modalEnergyPrice';
import cupsModal from '../../components/cupsModal'
import energyCalcComponent from '../../components/energyCalc'
import track from "../../components/track";

Vue.component('cups-modal', cupsModal)
Vue.component('energy-calculator', energyCalcComponent)
Vue.component('modal-energy-price', modalEnergyPrice)

new Vue({
    el: '#calculator-view',
    mounted: function() {
    },
    created: async function() {
        const section = document.getElementById('section1')
        if(section) {
            section.removeAttribute('hidden');
        }

        const section2 = document.getElementById('section2')
        if(section2) {
            section2.removeAttribute('hidden');
        }
    },
    data() {
        return {
            //Why goufone, fees, faq...
            menuSection: 'whyGoufone',
            // Calculate or Contract
            mainSection: 0,
            selected: {
                title: {
                    'ca': 'Selecciona la teva companyia actual',
                    'es': 'Selecciona tu compañía actual'
                },
                default: 'true',
            },
        }
    },
    computed: {
        classObject: function (data) {
            return {
                'energyMenuActivated': this.menuSection ===  data,
            }
        }
    },
    methods: {
        getMainSection(data) {
            this.mainSection = data;
            track.event({
                eventCategory: "energy",
                eventAction: "unfold",
                eventLabel: data,
            })
        },
        getMenuSection(data) {
            this.menuSection = data;
            track.event({
                eventCategory: "energy",
                eventAction: "sections",
                eventLabel: data,
            })
        }
    },
})
